import { flatten } from 'flat';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

export const isEmpty = (value: object | object[] | string | number) =>
  value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);

export const formChangeCounter = (
  values?: object | null,
  options?: {
    defaultValues?: object;
    compoundEntriesPaths?: string[];
    ignorePaths?: string[];
    ignoreWildcardPaths?: string[];
  }
) => {
  const { defaultValues, compoundEntriesPaths, ignorePaths, ignoreWildcardPaths } = options || {};
  const keys = Object.keys({
    ...flatten(values || {}, { safe: true }),
    ...flatten(defaultValues || {}, { safe: true })
  });

  const entries = keys
    .filter(key => {
      const presentValue = _get(values, key) || null;
      const defaultValue = _get(defaultValues, key) || null;

      if (isEmpty(presentValue) || ignorePaths?.includes(key)) return false;

      if (ignoreWildcardPaths?.some(path => key.startsWith(path))) return false;

      return !_isEqual(presentValue, defaultValue);
    })
    .map(originalEntry => {
      const compoundEntry = compoundEntriesPaths?.find(compoundEntryKey =>
        originalEntry.startsWith(`${compoundEntryKey}.`)
      );

      return compoundEntry ? compoundEntry : originalEntry;
    });

  return new Set(entries).size;
};
